import { useCallback, useEffect, useState } from 'react';

import { computeHoveredBackgroundColor } from './compute-hovered-background-color';

export const useBackgroundColorWithHoverState = (color?: string) => {
	const [backgroundColor, setBackgroundColor] = useState<string | undefined>();
	const [hoveredBackgroundColor, setHoveredBackgroundColor] = useState<string | undefined>();
	const [shownBackgroundColor, setShownBackgroundColor] = useState<string | undefined>();

	useEffect(() => {
		const hoveredBgColor = color ? computeHoveredBackgroundColor(color) : undefined;
		setBackgroundColor(color);
		setShownBackgroundColor(color);
		setHoveredBackgroundColor(hoveredBgColor);
	}, [color]);

	const handleHover = useCallback((): void => {
		setShownBackgroundColor(hoveredBackgroundColor);
	}, [hoveredBackgroundColor]);

	const handleUnhover = useCallback((): void => {
		setShownBackgroundColor(backgroundColor);
	}, [backgroundColor]);

	return {
		backgroundColor: shownBackgroundColor || backgroundColor,
		handleHover,
		handleUnhover,
	};
};
